import { EspecieModel } from "@src/core/domain/charge/especie.model";
import { Observable } from "rxjs";

export abstract class EspecieRepository {
  abstract get(): Observable<EspecieModel>;
}
